function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1667 7.49999C13.1667 7.06383 13.511 6.66666 13.9933 6.66666C14.4561 6.66666 14.8267 7.03718 14.8267 7.49999V18.4862L18.7398 14.5731C19.0684 14.2445 19.5916 14.2445 19.9202 14.5731C20.2488 14.9017 20.2488 15.4249 19.9202 15.7535L14.5733 21.1005L14.5587 21.113C14.4529 21.2036 14.3297 21.2663 14.2013 21.2984L14.1415 21.3133H14.1251C14.1122 21.3153 14.0967 21.3173 14.0791 21.3186C13.9557 21.3301 13.825 21.3168 13.6997 21.2713C13.5892 21.2331 13.492 21.1725 13.4064 21.0869L8.08002 15.7605C7.90037 15.5917 7.82666 15.3603 7.82666 15.1667C7.82666 14.9525 7.91374 14.7391 8.07311 14.5798C8.4017 14.2512 8.92495 14.2512 9.25355 14.5798L13.1667 18.4929V7.49999Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow_down.e4ac1064.svg";
export { SvgComponent as ReactComponent };